// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"296":"ac441d5764876205","647":"9ace6455c2b1dda7"}[chunkId] + ".css";
};